export default __webpack_public_path__ + "995fe0da4535a1cb02c8add92be2e039.png";